"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var GlobalizationContext_1 = require("../globalization/GlobalizationContext");
/**
 * @hidden
 */
exports.useLocalization = function () { return React.useContext(GlobalizationContext_1.GlobalizationContext).localization; };
//# sourceMappingURL=useLocalization.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-intl/dist/npm/hooks/useLocalization.js
// module id = 6612
// module chunks = 0